import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useState
} from 'react';
import {Col, Collapse, Form, FormInstance, Row, theme} from "antd";
import styled from 'styled-components'
import {observer} from "mobx-react";
import {useFormEventListener} from "../../provider/event/event.context.provider";
import {CollapseStyled} from "../../components/styled/collapse.styled";

const { Panel } = Collapse;

const StyleWrapper = styled.div`
    button + button {
        margin-left: 8px;
    }
    
    label {
        height: unset!important;
    }
`

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
    style: { padding: 16 }
};

export const FilterForm: React.FC<any> = observer(forwardRef((props, ref) => {
    const { token } = theme.useToken();
    const { notify } = useFormEventListener();

    const formReference = React.createRef<FormInstance>();
    const [ formElements, setFormElements ] = useState<any>(props.items ?? []);

    useImperativeHandle(ref, () => ({
        getForm: (): FormInstance | null => {
            return formReference.current;
        },
        submitForm: async () => {
            //we need to reset the form errors after submit press, for mixed server/client field validations
            formReference.current?.setFields(
                formReference.current?.getFieldsError().map((item) => ({
                    name: item.name,
                    errors: []
                }))
            )

            if (props.formErrors) {
                formReference.current?.setFields(
                    Object.keys(props.formErrors).map(fieldName => ({
                        name: fieldName,
                        errors: []
                    }))
                )
            }
            try {
                await formReference.current?.validateFields();

                //if at least one error in form, we do nothing
                if (formReference.current?.getFieldsError().some((item) => item.errors.length > 0)) {
                    return;
                }

                props.onFinish(formReference.current?.getFieldsValue());
            } catch (e) {}
        },
        resetForm: () => {
            formReference.current?.resetFields();
        },
        setData: (values: any) => {
            formReference.current?.setFieldsValue(values);
            notify({}, values)
        }
    }));

    useEffect(() => {
        setFormElements(props.items)
    }, [props.items])


    useEffect(() => {
        if (!props.formErrors) return;

        formReference.current?.setFields(
            Object.keys(props.formErrors).map(fieldName => ({
                name: fieldName.split('.'),
                errors: props.formErrors[fieldName]
            }))
        )
    }, [props.formErrors, formReference]);

    useEffect(() => {
        formReference.current?.setFields(Object.entries(props.store?.getSearchFields() ?? {}).map(([key, value]) => {
            return {
                name: key,
                value: value
            };
        }));
    },[])

    const formPositions = ['left', 'right'];

    const uniqueItems = (list: any, keyFn: any) => list.reduce((resultSet: any, item: any) =>
            resultSet.add(typeof keyFn === 'string' ? item[keyFn] : keyFn(item)),
    new Set()).size;

    return (
        <StyleWrapper>
            <Form ref={formReference} {...layout} layout="vertical"  style={{ padding: 0 }} onFinish={props.onFinish} onValuesChange={ (changedValues, values) => notify(changedValues, values) }>
                <CollapseStyled collapsible={ props.collapsible ? "icon" : "disabled" } key={`1`} defaultActiveKey={`1`} style={{
                    background: token.colorBgContainer,
                }}>
                    <Panel showArrow={props.collapsible ?? false} header={props.title} key="1">
                        <Row gutter={8}>
                            {
                                formPositions.map((position, a) => {
                                    let positionalElements = formElements.filter((element: any) => element.position === position);
                                    if (!positionalElements.length) return null;

                                    return (
                                        <Col key={position} span={24 / uniqueItems(formElements, 'position')}>
                                            {
                                                positionalElements.map((formBlock: any) => {
                                                    return (
                                                        formBlock.inputs.map((item: any, c: any) => {
                                                            const FormType = item ? item.type : null;

                                                            if (!FormType) return null;

                                                            return <FormType
                                                                key={c}
                                                                translationDomain={item.translationDomain ?? formBlock.translationDomain ?? props.translationDomain}
                                                                choiceTranslationDomain={ item.choiceTranslationDomain }
                                                                onClick={ item.onClick }
                                                                name={ item.name }
                                                                label={ item.label }
                                                                rules={ item.constraints }
                                                                choices={ item.choices }
                                                                multiple={ item.multiple }
                                                                vertical={ item.vertical }
                                                                expanded={ item.expanded }
                                                                firstFieldName={ item.firstFieldName }
                                                                secondFieldName={ item.secondFieldName }
                                                                firstLabel={ item.firstLabel }
                                                                secondLabel={ item.secondLabel }
                                                                firstFieldConstraints={ item.firstFieldConstraints }
                                                                secondFieldConstraints={ item.secondFieldConstraints }
                                                            />
                                                        })
                                                    )
                                                })
                                            }
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </Panel>
                </CollapseStyled>
            </Form>
        </StyleWrapper>
    )
}))